// Associe chaque colonne du fichier au champ choisi dans la modale ; les colonnes sans champ sont ignorées.
export function mapperLignesVersChamps(lignes, mapping) {
  return lignes.map((ligne) => {
    const objet = {};
    Object.entries(mapping).forEach(([colonne, champ]) => {
      if (champ) objet[champ] = ligne[colonne];
    });
    return objet;
  });
}
